import React from 'react';

interface MapLegendProps {
  entries: { name: string; color: string }[];
}

export const MapLegend: React.FC<MapLegendProps> = ({ entries }) => {
  if (entries.length === 0) return null;

  return (
    <div className="absolute bottom-4 left-4 bg-white rounded-lg shadow-lg border border-rgf-gray-200 p-3 z-[1000] max-w-[200px]">
      <h4 className="text-xs font-semibold text-rgf-gray-700 mb-2">Routes</h4>
      <div className="space-y-1.5">
        {entries.map(entry => (
          <div key={entry.name} className="flex items-center gap-2">
            <span
              className="h-3 w-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-xs text-rgf-gray-600 truncate">{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
